import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  paypalCreateOrder: {
    method: 'POST',
    url: `${configs.baseUrl}/api/pricing/paypal-create-order/`,
  },
  paypalCaptureOrder: {
    method: 'POST',
    url: `${configs.baseUrl}/api/pricing/paypal-capture-order/`,
  },
  getOfferOnCancellation: {
    method: 'POST',
    url: `${configs.baseUrl}/api/pricing/auto-offer-on-cancel/`,
  },
  extendSubscription: {
    method: 'POST',
    url: `${configs.baseUrl}/api/pricing/subscriptions/extend/`,
  },
  createStripeCheckoutSession: {
    method: 'POST',
    url: `${configs.baseUrl}/api/pricing/create-checkout-session/`,
  },
  createCustomerPortal: {
    method: 'POST',
    url: `${configs.baseUrl}/api/pricing/customer-portal/`,
  },

  hookBulkPricing: {
    method: 'POST',
    url: `${configs.baseUrl}/api/hook/bulk-licenses-requests/`,
  },
  createCustomerPortalUpgradeFlow: {
    method: 'POST',
    url: `${configs.baseUrl}/api/pricing/create-portal-flow-upgrade/`,
  },
  createCheckoutSessionForPersonPlan: {
    method: 'POST',
    url: `${configs.baseUrl}/api/pricing/create-checkout-session-for-personal-plan/`,
  },
  // Mints a per-user, single-redemption promo code for an allowlisted
  // campaign. Called post-login by the stripe-transition hop so landing-site
  // buyers get the campaign discount attached to Stripe checkout.
  generatePromoCode: {
    method: 'POST',
    url: `${configs.baseUrl}/api/pricing/generate-promo-code/`,
  },
  hookCustomRequest: {
    method: 'POST',
    url: `${configs.baseUrl}/api/hook/custom-plan-requests/`,
  },
  submitEnterpriseInquiriesForm: {
    method: 'POST',
    url: `${configs.baseUrl}/api/enterprise-inquiry/`,
  },
  // V2 endpoints for new bulk pricing
  createStripeCheckoutSessionV2: {
    method: 'POST',
    url: `${configs.baseUrl}/api/pricing/create-checkout-session-v2/`,
  },
  // v4 bulk checkout — accepts Stripe lookupKey, resolves variant-aware
  // lookup keys to a plan whose canonical `.type` is used for the
  // multi-license coupon lookup (legacy V2 lookup misses on variant keys).
  createBulkCheckoutSessionV4: {
    method: 'POST',
    url: `${configs.baseUrl}/api/pricing/v4/create-checkout-session`,
  },
  // v4 lookup_key based personal-plan checkout (free → new subscription). Resolves
  // the price variant-aware from the forwarded Stripe lookupKey, so the presenter
  // charges the same price the pricing page advertised for this viewer's bucket.
  createCheckoutSessionForPersonalPlanV4: {
    method: 'POST',
    url: `${configs.baseUrl}/api/pricing/v4/create-checkout-session-for-personal-plan`,
  },
  createCustomerPortalUpgradeFlowV2: {
    method: 'POST',
    url: `${configs.baseUrl}/api/pricing/create-portal-flow-upgrade-v2/`,
  },
  getMonthlyToYearlyUpgradePreview: {
    method: 'POST',
    url: `${configs.baseUrl}/api/pricing/yearly-upgrade-preview`,
  },
  createCustomerPortalUpgradeFlowV3: {
    method: 'POST',
    url: `${configs.baseUrl}/api/pricing/v3/create-portal-upgrade-flow/`,
  },
  // v4 lookup_key based portal upgrade (existing paying subscriber → Stripe
  // Customer Portal upgrade flow). Resolves the price variant-aware from the
  // forwarded Stripe lookupKey so the proration preview the subscriber confirms
  // matches the price the pricing page advertised for this viewer's bucket.
  createCustomerPortalUpgradeFlowV4: {
    method: 'POST',
    url: `${configs.baseUrl}/api/pricing/v4/create-portal-upgrade-flow/`,
  },
  // AHA-38492: Direct bulk purchase handler
  handleDirectBulkPurchase: {
    method: 'POST',
    url: `${configs.baseUrl}/api/pricing/direct-bulk-purchase`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const paypalCreateOrder = (payload) => {
  return resource.paypalCreateOrder(payload)
}
const createCheckoutSessionForPersonPlan = async (payload) => {
  const res = await resource.createCheckoutSessionForPersonPlan(payload)
  return res.body
}
const generatePromoCode = async (payload) => {
  const res = await resource.generatePromoCode(payload)
  return res.body
}

/**
 * @deprecated
 * Use createCustomerPortalUpgradeFlowV2 instead
 */
const createCustomerPortalUpgradeFlow = async (payload) => {
  const res = await resource.createCustomerPortalUpgradeFlow(payload)
  return res.body
}
const paypalCaptureOrder = (payload) => {
  return resource.paypalCaptureOrder(payload)
}

const getOfferOnCancellation = () => {
  return resource.getOfferOnCancellation()
}

const extendSubscription = async () => {
  return resource.extendSubscription()
}

/**
 * @deprecated
 * Use createStripeCheckoutSessionV2 instead
 */
const createStripeCheckoutSession = async (payload) => {
  const res = await resource.createStripeCheckoutSession(payload)
  return res.body
}
const hookBulkPricing = async (payload) => {
  const res = await resource.hookBulkPricing(payload)
  return res.body
}
const createCustomerPortal = async (payload) => {
  const res = await resource.createCustomerPortal(payload)
  return res.body
}

const hookCustomRequest = async (payload) => {
  const res = await resource.hookCustomRequest(payload)
  return res.body
}

const submitEnterpriseInquiriesForm = async (payload) => {
  const res = await resource.submitEnterpriseInquiriesForm(payload)
  return res.body
}

// V2 API methods for new bulk pricing
const createStripeCheckoutSessionV2 = async (payload) => {
  const res = await resource.createStripeCheckoutSessionV2(payload)
  return res.body
}

const createBulkCheckoutSessionV4 = async (payload) => {
  const res = await resource.createBulkCheckoutSessionV4(payload)
  return res.body
}

const createCheckoutSessionForPersonalPlanV4 = async (payload) => {
  const res = await resource.createCheckoutSessionForPersonalPlanV4(payload)
  return res.body
}

const createCustomerPortalUpgradeFlowV2 = async (payload) => {
  const res = await resource.createCustomerPortalUpgradeFlowV2(payload)
  return res.body
}

const createCustomerPortalUpgradeFlowV3 = async (payload) => {
  const res = await resource.createCustomerPortalUpgradeFlowV3(payload)
  return res.body
}

const createCustomerPortalUpgradeFlowV4 = async (payload) => {
  const res = await resource.createCustomerPortalUpgradeFlowV4(payload)
  return res.body
}

const getMonthlyToYearlyUpgradePreview = async (payload) => {
  const res = await resource.getMonthlyToYearlyUpgradePreview(payload)
  return res.body
}

// AHA-38492: Direct bulk purchase handler
const handleDirectBulkPurchase = async (payload) => {
  const res = await resource.handleDirectBulkPurchase(payload)
  return res.body
}

export default {
  initResource,
  paypalCreateOrder,
  paypalCaptureOrder,
  getOfferOnCancellation,
  extendSubscription,
  createStripeCheckoutSession,
  hookBulkPricing,
  createCustomerPortal,
  createCustomerPortalUpgradeFlow,
  createCheckoutSessionForPersonPlan,
  generatePromoCode,
  hookCustomRequest,
  submitEnterpriseInquiriesForm,
  // V2 exports
  createStripeCheckoutSessionV2,
  createBulkCheckoutSessionV4,
  createCheckoutSessionForPersonalPlanV4,
  createCustomerPortalUpgradeFlowV2,
  createCustomerPortalUpgradeFlowV3,
  createCustomerPortalUpgradeFlowV4,
  getMonthlyToYearlyUpgradePreview,
  handleDirectBulkPurchase,
}
